import authReducer from './auth.reducers';
import emailReportsReducer from './email-reports.reducers';

export * from './auth.reducers';
export * from './email-reports.reducers';

const reducers = {
  authentication: authReducer,
  emailReports: emailReportsReducer,
};

export default reducers;
